<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("form.title") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.title"
              :label="$t('form.title')"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.date"
              :label="$t('form.date')"
              prepend-inner-icon="event"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :value="$t('pressNew.media_types.' + pressNew.media_type)"
              :label="$t('form.pressNew.media_type')"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :value="$t('pressNew.scope_types.' + pressNew.scope)"
              :label="$t('form.pressNew.scope')"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.media"
              :label="$t('form.pressNew.media')"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.uri"
              :label="$t('form.pressNew.uri')"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        
        <h5>
          {{ $t("form.files") }}
        </h5>
        <UploadFiles
          :read-only="true"
          object_type="news"
          :id="Number(this.$route.params.id)"
          :final="false"
        />

        <v-divider />

        <DirectorActions
          v-if="isAuthorize"
          :object_type="object_type"
          class="text-center"
        />
        <SupervisorActions
          v-else
          :item="pressNew"
          :object_type="object_type"
          :form_name="form_name"
          :state="state"
          :supervisor="supervisor !== null ? supervisor.username : ''"
          @change-state-supervisor="onStateSupervisorChange"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import ArrayFieldForm from "../../reusables/ArrayFieldForm";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import project_data from "../../../mixins/project_data";
import project_model from "../../../mixins/model_utils/project_model";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import EditorText from "../../reusables/EditorText";
import UploadFiles from "../../reusables/UploadFiles";
import pressNew_data from "@/mixins/pressNew_data";
import pressNew_model from "@/mixins/model_utils/pressNew_model";

export default {
  mixins: [pressNew_data, pressNew_model],
  components: {
    DirectorActions,
    SupervisorActions,
    UploadFiles
  },

  data: () => ({
    form_name: "reviewPressForms",

    load_complete: false,
    state: "",
    title: "",
    reject_comment: "",
    object_id: null,
    object_type: "news",
    supervisor: ""
  }),

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/news/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.pressNew = response.data.data.user.pressNew;
          this.title = response.data.title;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.pressNew.id = response.data.object_id;
          this.form_name = response.data.form_name;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
